import * as React from "react";
import { HierarchyControl, HierarchyControlItem } from '../../basf-ui';
import { MapDataGroupId, MapDataSourceId, MapDataGroup, MapDataSource } from '../models/MapDataSource';
import { MAP_DATA_SORCES_DTO } from '../drafts/mapDataSources';
import { useMapStore } from "../hooks/useMapStore";
import { useMapDimension } from "../hooks/useMapDimension";
import { useHookSubscribe } from "../../react-rxjs";
import { MapDimension } from "../models/MapDimension";

interface ControlItem extends HierarchyControlItem<number> {

}

export const DimensionControl: React.FC<{ dimension?: MapDimension }> = ({ dimension }) => {
  const { loading, items, value, setValue } = useMapDimension<unknown>(dimension);

  const handlerChange = React.useCallback((value: unknown) => {
    setValue(value);
  }, []);

  const control = React.useMemo(() => {
    const label = dimension?.name || '';
    return <HierarchyControl inputLarge noSelectableParent={!dimension?.selectableParent} loading={loading || !dimension} label={label} value={value as any} items={items as any} onChange={handlerChange} />
  }, [items, loading, dimension, value]);

  return control;
};
